<template>
  <div>
    <section>
      <div>
        <h2>Reset Password</h2>
        <div>
          <p>Enter your email to reset your password</p>
          <form @submit.prevent>
            <div class="form-group">
              <input
                v-model.trim="email"
                type="email"
                placeholder="you@email.com"
                class="form-control"
              />
            </div>
          </form>
          <button
            v-if="showResetButton"
            @click="resetPassword()"
            class="button push-down-10 pointer"
          >
            Reset
          </button>
          <div class="relative" v-if='showLoading'>
            <loading
              color="rgb(187, 57, 54)"
              :active.sync="showLoading"
              :is-full-page="false"
              loader="bars"
            ></loading>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
export default {
  name: 'PasswordReset',
  components: { Loading },
  methods: {
    async resetPassword() {
      this.showResetButton = false
      // SHow the loading bar so it looks like something is happneing
      this.showLoading = true
      // Use the store to handle the reset password. Maybe shouldn't be part of the store however.
      await this.$store.dispatch('auth/resetPassword', this.email)
      this.showLoading = false
      this.showResetButton = true
    },
  },
  data: () => {
    return {
      // V-model for the text box
      email: '',
      showResetButton: true,
      showLoading: false,
    }
  },
}
</script>

<style lang='scss' scoped>
h3 {
  padding-top: 20px;
}

h2 {
  padding-top: 20px;
  padding-bottom: 10px;
}
.relative {
  position: relative;
  min-height:40px;
}
</style>